import React from 'react'
import { Link } from 'react-router-dom'
import { Navbar as BNavbar, Container } from 'react-bootstrap'

const Navbar = ({ currentUser }) => {
  if (!currentUser) return null

  return (
    <BNavbar expand="lg" bg="primary" variant="dark">
      <Container fluid>
        <button
          className="navbar-toggler d-lg-none"
          type="button"
          data-bs-toggle="offcanvas"
          data-bs-target="#sidebarOffcanvas"
          aria-controls="sidebarOffcanvas"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <BNavbar.Brand as={Link} to="/projects">
          Veduproект
        </BNavbar.Brand>
        <div className="ms-auto d-none d-lg-block">
          <span className="navbar-text me-3">{currentUser.email}</span>
        </div>
      </Container>
    </BNavbar>
  )
}

export default Navbar
